import { animateScroll } from 'react-scroll';

export const scrollToFirstError = (errors) => {
    if (Object.keys(errors).length) {
        setTimeout(() => {
            const elements = document.getElementsByClassName(`scroll-to-error`);
            if (elements.length) {
                animateScroll.scrollTo(elements[0].offsetTop - 100);
            }
        }, 200)
    }
}